import type { Dictionary } from "../i18n";

const dictionary: Dictionary = {
  "success.pendingTitle": "لا يزال تأكيد طلبك جاريًا",
  "success.pendingBody": "يستغرق تأكيد الدفع وقتًا أطول من المعتاد. يُرجى عدم الدفع مرة أخرى. يمكنك التحقق مجددًا أو العودة إلى طلبك أو التواصل مع الدعم مع ذكر رقم الطلب أدناه.",
  "success.cancelledTitle": "تم إلغاء هذا الطلب",
  "success.cancelledBody": "إذا تم خصم مبلغ من بطاقتك أو حجزه، فسيُعاد إليها. لا داعي لأي إجراء من جانبك.",
  "success.checkAgain": "التحقق مجددًا",

  "error.countryClosed": "لم تعد الطلبات الجديدة أو الدفع للطلبات غير المدفوعة متاحة في هذا البلد. تستمر معالجة الطلبات المدفوعة وتقديم الدعم.",
  "error.providerCountryClosed": "لم يعد بإمكان مقدم الخدمة المعيَّن تنفيذ طلبك. ابدأ طلبًا جديدًا وسنطابقك مع مقدم خدمة من جديد.",
  "chrome.reviewTitle": "مراجعة ودفع",
  "chrome.paidTitle": "تأكيد الطلب",
  "chrome.paymentTitle": "الدفع",
  "chrome.language": "اللغة",
  "chrome.close": "إغلاق",
  "chrome.logoAlt": "Tinkr",
  "common.loading": "جارٍ التحميل",
  "common.error": "حدث خطأ ما.",
  "common.retry": "حاول مرة أخرى",
  "common.labelSeparator": ": ",
  "trust.badge": "البائع Tinkr · الإنتاج لدى شريك طباعة محلي معتمد",
  "review.orderSummary": "ملخص الطلب",
  "review.threeD": "3D",
  "review.specsQty": "الكمية",
  "review.delivery.title": "التوصيل",
  "review.shipping.title": "تفاصيل الشحن",
  "review.shipping.edit": "تعديل",
  "review.payment.title": "طريقة الدفع",
  "review.payment.card": "بطاقة ائتمان أو خصم",
  "review.payment.cardHint": "Visa وMastercard وغيرها",
  "review.payment.usdc": "عملة USDC المستقرة",
  "review.payment.comingSoon": "قريبًا",
  "review.price.title": "السعر",
  "review.price.itemSubtotal": "المجموع الفرعي للمنتجات",
  "review.price.premium": "تصنيع مميز",
  "review.price.shipping": "الشحن",
  "review.price.shippingIncluded": "مشمول",
  "review.price.total": "إجمالي الطلب",
  "review.price.taxNote": "لا تفرض Tinkr ضريبة معاملات على هذا الطلب.",
  "review.price.updating": "جارٍ تحديث الإجمالي…",
  "review.price.refreshError": "تعذّر تحديث الإجمالي. أعد تحميل الصفحة قبل الدفع.",
  "review.price.multicolor": "متعدد الألوان",
  "review.price.multicolorCapNote": "لم نتمكن من قياس هذا المجسم بدقة، لذا يُطبَّق الحد الأقصى لسعر تعدد الألوان.",
  "review.pricing.calculating": "جارٍ حساب سعرك الدقيق…",
  "review.pricing.calculatingBody": "يُحسب سعر مجسمك متعدد الألوان من طباعته الخاصة. يستغرق ذلك عادةً أقل من دقيقة.",
  "review.pricing.from": "ابتداءً من",
  "review.pricing.stillWorking": "ما زلنا نعمل على ذلك. شكرًا لصبرك.",
  "review.pricing.timeout": "لم نتمكن من إكمال حساب سعرك. يُرجى المحاولة مرة أخرى.",
  "review.consent.prefix": "بتحديد هذا الخيار، فإنك توافق على",
  "review.consent.terms": "شروط خدمة Tinkr",
  "review.consent.and": "و",
  "review.consent.privacy": "سياسة الخصوصية",
  "review.cta.pay": "ادفع",
  "review.cta.secure": "دفع آمن",
  "coupon.toggle": "هل لديك رمز قسيمة؟",
  "coupon.label": "رمز القسيمة",
  "coupon.placeholder": "أدخل الرمز",
  "coupon.apply": "تطبيق",
  "coupon.applying": "جارٍ التطبيق…",
  "coupon.remove": "إزالة",
  "coupon.removing": "جارٍ الإزالة…",
  "coupon.appliedLabel": "القسيمة",
  "coupon.error.notFound": "تعذّر العثور على رمز القسيمة هذا",
  "coupon.error.expired": "انتهت صلاحية هذه القسيمة",
  "coupon.error.revoked": "لم تعد هذه القسيمة صالحة",
  "coupon.error.notStarted": "هذه القسيمة غير مفعّلة بعد",
  "coupon.error.notApplicable": "لا يمكن استخدام هذه القسيمة لهذا الطلب",
  "coupon.error.usageLimit": "بلغت هذه القسيمة حد الاستخدام",
  "coupon.error.alreadyApplied": "تم تطبيق هذه القسيمة بالفعل",
  "coupon.error.retry": "انتظر لحظة ثم حاول مرة أخرى",
  "coupon.error.generic": "لا يمكن استخدام هذا الرمز",
  "redirect.title": "جارٍ نقلك إلى الدفع الآمن…",
  "redirect.subtitle": "جارٍ إعادة توجيهك إلى صفحة الدفع الآمنة لدى Stripe.",
  "redirect.badgeVerified": "تم التحقق",
  "redirect.badgeEncrypted": "مشفّر",
  "redirect.badgeSsl": "اتصال SSL آمن",
  "success.title": "اكتمل الدفع!",
  "success.authorizedTitle": "تم تأكيد الطلب!",
  "success.orderNumber": "رقم الطلب",
  "success.paidTotal": "المبلغ المدفوع",
  "success.authorizedTotal": "حجز مؤقت على البطاقة",
  "success.nextTitle": "ماذا سيحدث الآن",
  "success.step1": "تم إشعار شريك الطباعة",
  "success.step2": "سيطبع الطلب ويفحص جودته",
  "success.step3": "ثم يشحنه إليك",
  "success.statusCompleted": "مكتمل",
  "success.statusPending": "قيد التنفيذ",
  "success.statusUpcoming": "قادم",
  "success.track": "تتبّع طلبك",
  "success.viewOrder": "عرض طلبك ←",
  "success.back": "العودة إلى Tinkr",
  "success.returnToDoodles": "العودة إلى Tinkr Doodles",
  "success.returnToSite": "العودة إلى طلبك",
  "success.confirming": "جارٍ تأكيد طلبك…",
  "success.notConfirmed": "تعذّر تأكيد طلبك حتى الآن. تحقّق مرة أخرى بعد بضع دقائق.",
  "cancelled.title": "لقد غادرت صفحة الدفع",
  "cancelled.body": "تم حفظ طلبك. قد يستغرق تحديث حالة الدفع بعض الوقت.",
  "cancelled.orderRef": "رقم الطلب",
  "cancelled.tip": "تحقّق من اتصالك أو موافقة البنك ثم حاول مرة أخرى.",
  "cancelled.retry": "حاول مرة أخرى",
  "cancelled.help": "مساعدة",
  "footer.terms": "شروط الخدمة",
  "footer.privacy": "الخصوصية",
  "footer.refund": "المبالغ المستردة والإلغاء",
  "footer.seller": "معلومات البائع",
  "footer.tokushoho": "إشعار قانون المعاملات التجارية المحددة",
  "footer.entity": "Tinkr App Ltd",
  "footer.companyNo": "رقم الشركة",
  "legal.back": "رجوع",
  "legal.updated": "آخر تحديث",
  "error.notFound": "تعذّر العثور على رابط الدفع هذا. تحقّق من الرابط الوارد في بريدك الإلكتروني.",
  "error.expired": "انتهت صلاحية رابط الدفع هذا.",
  "error.alreadyPaid": "تم دفع قيمة هذا الطلب بالفعل.",
  "error.payFailed": "تعذّر بدء الدفع. حاول مرة أخرى.",
  "error.couponNoLongerValid": "لم تعد قسيمة هذا الطلب صالحة. أزلها ثم حاول مرة أخرى.",
  "error.couponLimitReached": "بلغت هذه القسيمة حد الاستخدام حاليًا. أزلها للمتابعة، أو حاول مرة أخرى لاحقًا.",
  "error.couponNotApplicable": "لا يمكن استخدام هذه القسيمة مع إجمالي هذا الطلب. أزلها ثم حاول مرة أخرى.",
  "error.paymentConfirming": "يجري تأكيد دفعتك بالفعل. انتظر قليلًا ثم حدّث هذه الصفحة.",
  "error.sessionConflict": "تغيّرت عملية الدفع في نافذة أخرى. يرجى المحاولة مرة أخرى.",
  "error.recoveryHint": "افتح أحدث رسالة بريد إلكتروني عن طلبك للحصول على رابط دفع جديد، أو تواصل مع الدعم وسنساعدك.",
  "error.backToSite": "العودة إلى الموقع"
};

export default dictionary;
